import api from './api';

export const authService = {
  login,
  refreshToken,
  logout,
};

function login(email, senha, id_licenca) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/autenticacao/login`, { email, senha, id_licenca });
}

function refreshToken(refresh_token) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/autenticacao/token`, { refresh_token });
}

function logout(refresh_token) {
  // remove auth from locaStorage to log auth out
  return api.delete(`${process.env.VUE_APP_ROOT_API}/autenticacao/logout?refresh_token=${refresh_token}`);
}